export const props = {
  MuiLink: {
    underline: 'always',
  },
};
